import { useQuery } from '@tanstack/react-query';

import { _getBffContactById } from '@/api/address-book-bff/queries';

export const usePreviewContact = (contactId?: string) =>
  useQuery({
    ..._getBffContactById(contactId),
    refetchOnMount: false,
    staleTime: 5 * 60 * 1000,
  });
